import { DateTime } from 'luxon';

export const VsTagExpirationDateMixin = {
  methods: {
    vsExpirationDate(timezone, orderDt = null) {
      let dateNow = DateTime.now();

      if (orderDt) {
        dateNow = DateTime.fromISO(orderDt).setZone(timezone);
      }

      if (!dateNow && timezone) {
        dateNow = DateTime.now().setZone(timezone);
      }

      const targetMonth = 11;
      const cutOffDate = DateTime.local(dateNow.year, targetMonth, 1);

      const expirationDate = dateNow > cutOffDate ? dateNow.plus({ years: 1 }) : dateNow;

      return expirationDate.set({ month: 12, day: 31 }).toFormat('LLL d, yyyy');
    },
    vsExpirationDateProductFormat(product, orderDt = null) {
      if (product && !(product.subType === 'pet guardian' || (product.type === 'PET_TAG' && product.name.includes('V&S')))) {
        return null;
      }

      return `(Expires on ${this.vsExpirationDate(this.timezone, orderDt)})`;
    },
  },
  computed: {
    timezone() {
      return (
        (this.order && this.order.city && this.order.city.timezone) ||
        (this.petOwner && this.petOwner.city && this.petOwner.city.timezone) ||
        null
      );
    },
    vsExpirationDateTagFormat() {
      return `(Voice & Sight Tag will expire on ${this.vsExpirationDate(this.timezone)})`;
    },
  },
};
